// extracted by mini-css-extract-plugin
export var bounce = "b2uLo";
export var iconPhasesAnimation = "pDUOV";
export var loadingScreen = "_yXYl";
export var msLogo = "SAPHP";